import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import CatalogItems from "./components/CatalogItems";
import { withRouter } from "react-router-dom";

class Training extends Component {
  state = { trainingType: "pci" };

  // componentDidMount() {
  //   //this.getSeason();
  // }

  // getSeason() {
  //   const currentType = this.props.match.params.trainingType || null;
  //   if (!currentType) {
  //     this.props.history.push("/app/training/hipaa");
  //   }
  //   this.setState({ trainingType: currentType });
  // }

  render() {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">PCI Training</h3>
            {/* <h3 className="page-subhead subhead">
              Interactive videos to help your team with security and HIPAA
              awareness.
            </h3> */}
            <h3 className="page-subhead subhead">
              Build your PCI awareness by watching these short 
              and interesting videos. To ensure that you adhere to your 
              organization’s policies and earn some cool certificates, 
              make sure you take the corresponding quiz.
            </h3>
          </Col>
        </Row>
        <Row>
          <CatalogItems active={this.state.trainingType} />
        </Row>
      </Container>
    );
  }
}
export default withRouter(Training);



// WEBPACK FOOTER //
// ./src/components/training/PCITraining.js